import { PageLoader } from '@customerio/pluma-components/react';
import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense, useState } from 'react';

import { isEmbedEditorInHydra } from '@/services/router/design-studio-embed-gate';
import { RumPageRendered } from '@/services/rum/use-page-rendered';

import { EmbedDesignStudioRoute } from './-route-layouts';

// The email composer's iframe editor (Journeys). Lazy, so the editor (and the page module, which marks the page
// as embedded when it loads) stays out of every other chunk.
const EmailEmbedPage = lazy(() => import('@/pages/workspaces/design-studio/embed/cio/email/embed-route.page'));

function EmailEmbedRoute() {
  // Decided once: the embedding page's flag doesn't change under a mounted editor.
  const [isInHydra] = useState(isEmbedEditorInHydra);

  if (!isInHydra) {
    return <EmbedDesignStudioRoute />;
  }

  return (
    <Suspense fallback={<PageLoader />}>
      <RumPageRendered>
        <EmailEmbedPage />
      </RumPageRendered>
    </Suspense>
  );
}

export const Route = createFileRoute('/design-studio-embed/cio/email')({
  component: EmailEmbedRoute,
});
